var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({'color': !_vm.inStock ? 'red' : ''}),domProps:{"innerHTML":_vm._s(_vm.inStock ? _vm.value : 'SOLD OUT')}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-496bb88c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Price.vue
// module id = jJRn
// module chunks = 116